<div class="mg-t-5">
  <p-selectButton #selectItems
                  [options]="items"
                  optionLabel="label"
                  [(ngModel)]="selectedItem"
                  (onChange)="changeSelectedItem($event)">
  </p-selectButton>
</div>

<div class="mg-t-20">
  <router-outlet></router-outlet>
</div>
